<template>
  <div class="col border-b">
    <div>
      <div class="input-group mt-2 d-none d-lg-flex">
        <div class="input-group-prepend d-none d-lg-none">
          <label
            for="inputGroupSelect01"
            class="input-group-text"
            data-test="sortMenuLabel"
            id="sortMenuLabel"
          >Sort by:</label>
        </div>
        <select
          id="inputGroupSelect01"
          class="custom-select"
          @change="sortProducts(index)"
          v-model="index"
          data-test="sortMenuSelect"
        >
          <option
            v-for="(order,index) in sortOptions"
            :key="index"
            :value="index"
            :data-test="'sortMenuOption'+index"
            :id="'sortMenuOption'+index"
          >{{ order.name}}</option>
        </select>
      </div>
      <div class="input-group d-block d-lg-none">
        <div class="sort-toggle">
          <button
            class="sort-toggle-btn"
            id="sort-btn"
            @click.prevent="showSortBlock(index)"
            data-test="sortMenuSortBtn"
          >
            <i class="fas fa-sort-amount-down" data-test="sortMenuSortIcon"
															id="sortMenuSortIcon"></i>
            Sort
          </button>
        </div>
      </div>
    </div>
    <!--<sort-tab :sortOptions="sortOptions"-->
    <!--@showSortBlock="showSortBlock($event)"-->
    <!--&gt;-->

    <!--</sort-tab>-->
  </div>
</template>
<script>
import { productApi } from '@/services/ApiServices/productApi'
import { mapGetters } from 'vuex'

export default {
	name: 'sort-menu',
	computed: {
		...mapGetters('filters', ['isFilterApplied', 'getFilterClass'])
	},
	data () {
		return {
			index: 0,
			sortOrder: '',
			sortMethod: '',
			sortOptions: [
				{
					name: 'Name A->Z',
					sortOrder: 'ASC',
					sortMethod: 'NAME'
				},
				{
					name: 'Name Z->A',
					sortOrder: 'DES',
					sortMethod: 'NAME'
				},
				{
					name: 'Vendor A->Z',
					sortOrder: 'ASC',
					sortMethod: 'VENDOR'
				},
				{
					name: 'Vendor Z->A',
					sortOrder: 'DES',
					sortMethod: 'VENDOR'
				},
				{
					name: 'Popularity',
					sortOrder: 'DES',
					sortMethod: 'SALES'
				},
				{
					name: 'Price Low to High',
					sortOrder: 'ASC',
					sortMethod: 'PRICE'
				},
				{
					name: 'Price High to Low',
					sortOrder: 'DES',
					sortMethod: 'PRICE'
				}
			]
		}
	},
	watch: {
		$route () {
			this.index = 0
		}
	},
	methods: {
		sortProducts (index) {
			this.sortOrder = this.sortOptions[index].sortOrder
			this.sortMethod = this.sortOptions[index].sortMethod
			let searchKey = {}
			let urlReference = 'filteredSearchProducts'
			if (this.$route.path === '/all-products') {
				if (!this.isFilterApplied) {
					searchKey = {
						key: 'getAllProducts'
					}
				}
				urlReference = 'filteredAllProducts'
			} else if (this.$route.path === '/search-results') {
				searchKey = {
					is_a_category: this.$route.query.is_a_category,
					category_id: this.$route.query.category_id,
					search_name: this.$route.query.search_name
				}
			} else if (this.$route.path === '/product-list') {
				searchKey = {
					is_a_category: this.$route.query.is_a_category,
					category_id: this.$route.query.category,
					name: this.$route.query.name,
					depth: this.$route.query.depth
				}
			}
			this.sortPLPProducts(searchKey, urlReference)
		},
		sortPLPProducts (searchKey, urlReference) {
			let apiData = {}
			if (this.isFilterApplied) {
				apiData = {
					filter_class: this.getFilterClass,
					query_parameter: searchKey
				}
			} else {
				apiData = { query_parameter: searchKey }
			}
			if (searchKey.key === 'getAllProducts') {
				const filterData = {
					filter_class: { filters: [], brands: [], ratings: [] }
				}
				productApi.getSearchedFilteredProducts(
					filterData,
					'filteredAllProducts',
					this.sortOrder,
					this.sortMethod
				)
			} else if (apiData.filter_class) {
				productApi.getSearchedFilteredProducts(
					apiData,
					urlReference,
					this.sortOrder,
					this.sortMethod
				)
			} else {
				urlReference = 'searchProducts'
				productApi.getSearchedFilteredProducts(
					apiData,
					urlReference,
					this.sortOrder,
					this.sortMethod
				)
			}
		},
		showSortBlock (index = 0) {
			if (document.querySelector('.sorty-tab').classList.contains('shown')) {
				this.sortProducts(index)
				document.querySelector('.sorty-tab').classList.remove('shown')
				document.querySelector('body').classList.remove('backdrop')
			} else {
				document.querySelector('.sorty-tab').classList.add('shown')
				// document.querySelector('body').classList.add('backdrop');
			}
		}
	}
}
</script>
